
import { createSlice } from '@reduxjs/toolkit'

import { planningShiftsAdapter } from '../adapters/planningShiftsAdapter'

export const initialPlanningShiftState = planningShiftsAdapter.getInitialState()

export const planningShiftsSlice = createSlice({
  name: 'shifts',
  initialState: initialPlanningShiftState,
  reducers: {
    upsertMultiplePlanningShifts: (state, action) => {
      planningShiftsAdapter.upsertMany(state, action.payload)
    },
    replaceAllPlanningShifts: (state, action) => {
      planningShiftsAdapter.setAll(state, action.payload)
    },
    removePlanningShift: (state, action) => {
      planningShiftsAdapter.removeOne(state, action.payload.id)
    },
  },
})

export const { upsertMultiplePlanningShifts, removePlanningShift, replaceAllPlanningShifts } = planningShiftsSlice.actions